import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-pricing-table5',
  templateUrl: './pricing-table5.component.html',
  styleUrls: ['./pricing-table5.component.scss']
})
export class PricingTable5Component implements OnInit, OnDestroy{

  url = '';
  sanitizedUrl = '';


  priceForm: FormGroup;
  formData:any;
  btntext:string;
  @Output() setData3 = new EventEmitter<any>();
  @Input() priceplandata3: any;
  
  constructor(private fb: FormBuilder, private snackBar: MatSnackBar, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit() {
    this.createForm();
    this.populateForm();
//    console.log(this.priceplandata);
  }

  populateForm() {
    if (this.priceplandata3) {
      const pricedetailFormArray = this.priceForm.get('pricedetail') as FormArray;
  
      // Clear existing controls
      while (pricedetailFormArray.length !== 0) {
        pricedetailFormArray.removeAt(0);
      }
  
      this.priceplandata3.forEach((detail: any) => {
        const detailFormGroup = this.fb.group({
          title: detail.title,
          title1: detail.title1,
          title2: detail.title2,
          title3: detail.title3,
          s_price_annualy: detail.s_price_annualy,          
          p_price_annualy: detail.p_price_annualy,          
          a_price_annualy: detail.a_price_annualy,         
          s_price_life: detail.s_price_life,          
          p_price_life: detail.p_price_life,          
          a_price_life: detail.a_price_life,  

          s_charge_year: detail.s_charge_year,          
          p_charge_year: detail.p_charge_year,          
          a_charge_year: detail.a_charge_year,         
          s_charge_life: detail.s_charge_life,          
          p_charge_life: detail.p_charge_life,          
          a_charge_life: detail.a_charge_life,            

          s_button: detail.s_button,          
          p_button: detail.p_button,          
          a_button: detail.a_button,         
          s_subtitle: detail.s_subtitle,          
          p_subtitle: detail.p_subtitle,          
          a_subtitle: detail.a_subtitle,            
          


          list_detail: this.fb.array([])
        });
  
        const listDetailFormArray = detailFormGroup.get('list_detail') as FormArray;
  
        detail.list_detail.forEach((item: any) => {
          const listItemFormGroup = this.fb.group(item);
          listDetailFormArray.push(listItemFormGroup);
        });
  
        pricedetailFormArray.push(detailFormGroup);
      });
      this.btntext = 'Update';
    }
  }
  

  createForm() {
    this.priceForm = this.fb.group({
      pricedetail: this.fb.array([])
    });

    // Initialize form with empty values
    this.addPricingDetails();
    this.btntext = 'Submit';
  }

  get pricedetail(): FormArray {
    return this.priceForm.get('pricedetail') as FormArray;
  }

  addPricingDetails() {
    this.pricedetail.push(this.fb.group({
      title: '',
      title1: '',
      title2: '',
      title3: '',
      s_price_annualy:'',
      p_price_annualy:'',
      a_price_annualy:'',
      s_price_life:'',
      p_price_life:'',
      a_price_life:'',      
      s_charge_year: '',          
      p_charge_year: '',          
      a_charge_year: '',         
      s_charge_life: '',          
      p_charge_life: '',          
      a_charge_life: '',            
      s_button: '',          
      p_button: '',          
      a_button: '',         
      s_subtitle: '',          
      p_subtitle: '',          
      a_subtitle: '',            

      list_detail: this.fb.array([])
    }));

    // You can initialize with default values if needed
    this.addListDetail(this.pricedetail.length - 1);
  }

  addListDetail(index: number) {
    const listDetail = this.pricedetail.at(index).get('list_detail') as FormArray;
    
    listDetail.push(this.fb.group({
      starters: '',
      professions: '',
      advanceds: '',
      sub_title:'',
      types:'',
      value:'',
      require:''
    }));
  }

  deletePricingDetail(index: number) {
    this.pricedetail.removeAt(index);
  }

  deleteListDetail(detailIndex: number, listIndex: number) {
    const listDetail = this.pricedetail.at(detailIndex).get('list_detail') as FormArray;
    listDetail.removeAt(listIndex);
  }

  onSubmit() {
    // Transform form values to match the provided JSON structure
    this.formData = this.priceForm.value.pricedetail.map((detail) => {
      return {
        title: detail.title,
        title1: detail.title1,
        title2: detail.title2,
        title3: detail.title3,

        s_price_annualy: detail.s_price_annualy,          
        p_price_annualy: detail.p_price_annualy,          
        a_price_annualy: detail.a_price_annualy,         
        s_price_life: detail.s_price_life,          
        p_price_life: detail.p_price_life,          
        a_price_life: detail.a_price_life,  

        s_charge_year: detail.s_charge_year,          
        p_charge_year: detail.p_charge_year,          
        a_charge_year: detail.a_charge_year,         
        s_charge_life: detail.s_charge_life,          
        p_charge_life: detail.p_charge_life,          
        a_charge_life: detail.a_charge_life,            

        s_button: detail.s_button,          
        p_button: detail.p_button,          
        a_button: detail.a_button,         
        s_subtitle: detail.s_subtitle,          
        p_subtitle: detail.p_subtitle,          
        a_subtitle: detail.a_subtitle,            

        list_detail: detail.list_detail.map((item) => {
          return {
            types: item.types,
            starters: item.starters,
            professions: item.professions,
            advanceds: item.advanceds,
            sub_title:item.sub_title,
            value: item.value,
            require:item.require
          };
        })
      };
    });
   // this.snackBar.open("Data saved Ok..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    console.log(this.formData);
    this.emit();
  }

  emit(){
    this.setData3.emit(this.formData)
  }

  catType: any = [
    { "value": "1", "viewValue": "Image" },
    { "value": '2', "viewValue": "Text" },
  ]

  mandatory: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": '2', "viewValue": "No" },
  ]




  updatesImageArray(event, i, value, j) {
    this.priceForm.value.pricedetail[i]['list_detail'][j][value] =  event.productEntityMediaGallery[0].fileName;;
    this.priceForm.patchValue(this.priceForm.value);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });
  }

  deletImageArray(event, i, value, j) {
    this.priceForm.value.pricedetail[i]['list_detail'][j][value] = '';
    this.priceForm.patchValue(this.priceForm.value);
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
